import React from 'react';
import PropTypes from 'prop-types';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { Box, TopbarWrapper } from '../design/css';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const BusinessPlansTable = ({ businessAppPlans, onDelete, isDeletable }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    businessAppTable: { productLabel, monthlyChargesLabel, oneTimeChargesLabel , quantityLabel, deleteLabel },
    formButtons: { deleteButtonLabel }
  } = localizedStrings;
  const totlDevices = businessAppPlans.reduce((acc, item) => acc + +item.quantity, 0);

  return (
    <Box
      style={{
        margin: '2rem 0',
        border: '1px solid #e3e3e3',
        boxShadow: '1px 1px 9px 4px #e3e3e3'
      }}
    >
      <TopbarWrapper
        style={{ color: '#fff' }}
      >{`Services (${totlDevices})`}</TopbarWrapper>
      <Table>
        <Thead style={{ background: '#e2e2e2' }}>
          <Tr>
            <Th>#</Th>
            <Th>{productLabel}</Th>
            <Th style={{textAlign: 'center'}}>{monthlyChargesLabel}</Th>
            <Th style={{textAlign: 'center'}}>{oneTimeChargesLabel}</Th>
            <Th style={{textAlign: 'center'}}>{quantityLabel}</Th>
            {isDeletable && <Th style={{textAlign: 'center'}}>{deleteLabel}</Th>}
          </Tr>
        </Thead>
        <Tbody>
          {businessAppPlans.map((item, index) => {
            const { name, monthlyCharges, oneTimeCharges , quantity } = item;
            const rowKey = `row${index}`;

            return (
              <Tr
                key={rowKey}
                style={{
                  background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
                }}
              >
                <Td width="10%">{index + 1}</Td>
                <Td width="40%">{name}</Td>
                <Td width="15%" style={{textAlign: 'center'}}>{`$${monthlyCharges}`}</Td>
                <Td width="15%" style={{textAlign: 'center'}}>{`$${oneTimeCharges}`}</Td>
                <Td width="15%" style={{textAlign: 'center'}}>{quantity}</Td>
                {isDeletable && 
                <Td width="20%" style={{textAlign: 'center'}}>
                  <button
                    type="button"
                    className="btn btn-link"
                    style={{ color: '#4B286D', textDecoration: 'underline' }}
                    onClick={() => onDelete(index)}
                  >
                    {deleteButtonLabel}
                  </button>
                </Td>
          }
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

BusinessPlansTable.propTypes = {
    businessAppTable: PropTypes.arrayOf(
    PropTypes.shape({
        productLabel: PropTypes.string,
        monthlyChargesLabel: PropTypes.number,
        oneTimeChargesLabel: PropTypes.number,
        quantityLabel: PropTypes.number
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default BusinessPlansTable;
